import { render, staticRenderFns } from "./agent.vue?vue&type=template&id=65e9e042&scoped=true"
import script from "./agent.vue?vue&type=script&lang=js"
export * from "./agent.vue?vue&type=script&lang=js"
import style0 from "./agent.vue?vue&type=style&index=0&id=65e9e042&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e9e042",
  null
  
)

export default component.exports